import Form from "./Form";

export default class QueryPreloader
{
	constructor(el)
	{
		this.el = el;
	}

	static selector = () => `${Form.selector()}__preloader`;

	hide()
	{
		this.el.hidden = true;

		return this;
	}

	show()
	{
		this.el.hidden = false;

		return this;
	}
}
